import { DefaultPalette, mergeStyleSets } from "@fluentui/react";
import React from "react";
import { $gray800 } from "../../../cssjs/colors";
import { CommonHelper } from "../../../utils/common/CommonHelper";

type CardProps = {
  children: React.ReactElement;
  header?: React.ReactElement;
  width: number | string;
  height: number;
  className?: string;
  dataTestId?: string;
  id?: string;
  onClick?: any;
  headerType?: "default_header" | "custom_header";
  bodyType?: "default_body" | "custom_body";
  footerType?: "none" | "default_footer";
  headerAlignment?: "space-between" | "center";
  footer?: React.ReactNode;
};

const Card: React.FunctionComponent<CardProps> = ({
  width = 386,
  height = 170,
  className = "",
  dataTestId = "",
  headerType = "custom_header",
  bodyType = "custom_body",
  footerType = "none",
  headerAlignment = "space-between",
  ...props
}) => {
  const cardStyles = mergeStyleSets({
    root: {
      background: DefaultPalette.white,
      width,
      height,
      justifyContent: "center",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
      borderRadius: "5px",
      cursor: "pointer",
      padding: headerType === "default_header" ? 13 : 0,
    },
    header: {
      display: "flex",
      justifyContent: headerAlignment,
      paddingBottom: 10,
      selectors: {
        "& span": {
          fontSize: 14,
          lineHeight: 18,
          color: $gray800,
          fontWeight: 600,
        },
      },
    },
    body: {
      height: 54,
      paddingTop: 13,
      paddingBottom: 13,
    },
    footer: {
      height: 32,
    },
  });

  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <div
      className={`${cardStyles.root} ${className}`}
      data-testid={dataTestId}
      onClick={() => handleClick()}
      key={CommonHelper.getGuid()}
    >
      {headerType === "custom_header" && <>{props.children}</>}
      {headerType === "default_header" && (
        <div className={cardStyles.header}>{props.header}</div>
      )}
      {bodyType === "custom_body" && <div>{props.children}</div>}
      {bodyType === "default_body" && (
        <div className={cardStyles.body}>{props.children}</div>
      )}
      {footerType === "default_footer" && (
        <div className={cardStyles.footer}>{props.footer}</div>
      )}
    </div>
  );
};

export default Card;
